import { Keyboard } from 'react-native';
import {
  BottomSheetContainer,
  createUseBottomSheetModal,
  useSafeArea,
  useScreenSize,
} from '@banhala/ui-kit';
import { KeyboardAvoiding } from 'shared/src/component';
import { isIOS } from 'shared/src/utils';
import { useCreateFolder } from '../../../queries/useCreateFolder';
import { FolderNameEditor } from '../components/FolderNameEditor';

export const useCreateFolderBottomSheet = createUseBottomSheetModal<
  { folderSno: number; folderName: string },
  void
>(({ confirm, cancel }) => {
  const { mutateAsync: createFolder } = useCreateFolder();
  const { bottom, top } = useSafeArea();
  const { height: screenHeight } = useScreenSize();

  const sheet = (
    <BottomSheetContainer
      onPressClose={() => {
        Keyboard.dismiss();
        cancel();
      }}
      minHeight={isIOS ? (screenHeight - bottom - top) / 3 : 0}
      title="새 서랍 추가"
    >
      <FolderNameEditor
        initialValue=""
        validate={value => value.length > 0}
        onSubmit={async value => {
          const {
            data: { sno },
          } = await createFolder({ title: value });
          confirm({ folderSno: sno, folderName: value });
        }}
        onClose={cancel}
      />
    </BottomSheetContainer>
  );

  // 웹 분기는 KeyboardAvoiding(shared) 안에 있다 — 웹에선 no-op.
  return <KeyboardAvoiding>{sheet}</KeyboardAvoiding>;
});
